import React from 'react'
import { NavLink as RRNavLink } from 'react-router-dom'
import {
  Container,
  Nav, NavItem,
  NavLink
} from 'reactstrap'
import "./Navigation.scss"

export default function(props) {
  const { toggle } = props

  return (
    <Container fluid className="d-flex justify-content-center">
      <Nav className="Nav" navbar>
        <NavItem>
          <NavLink onClick={toggle} activeClassName="nav-active" tag={RRNavLink} exact to="/">Home</NavLink>
        </NavItem>
        <NavItem>
          <NavLink onClick={toggle} activeClassName="nav-active" tag={RRNavLink} to="/new-releases">New Releases</NavLink>
        </NavItem>
        <NavItem><NavLink onClick={toggle} activeClassName="nav-active" tag={RRNavLink} to="/voices-series">Voices Series</NavLink></NavItem>
        <NavItem><NavLink onClick={toggle} activeClassName="nav-active" tag={RRNavLink} to="/articles">Articles</NavLink></NavItem>
        <NavItem><NavLink onClick={toggle} activeClassName="nav-active" tag={RRNavLink} to="/news">News</NavLink></NavItem>
        <NavItem><NavLink onClick={toggle} activeClassName="nav-active" tag={RRNavLink} exact to="/about">About</NavLink></NavItem>
        <NavItem><NavLink onClick={toggle} activeClassName="nav-active" tag={RRNavLink} to="/contact">Contact</NavLink></NavItem>
      </Nav>
    </Container>
  )
}
